import { useLocale } from "@/context/LocaleContext";

export function LocaleSwitcher() {
  const { locale, setLocale } = useLocale();
  return (
    <div className="inline-flex items-center rounded-full border border-border p-0.5" data-testid="locale-switcher">
      {[
        { code: "da", label: "DA" },
        { code: "en", label: "EN" },
      ].map((o) => (
        <button
          key={o.code}
          data-testid={`locale-${o.code}`}
          onClick={() => setLocale(o.code)}
          className={`px-2.5 py-1 rounded-full text-xs font-medium transition-colors duration-200 ${
            locale === o.code ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
